import { render, staticRenderFns } from "./IconSelectDown.vue?vue&type=template&id=075a0c2b"
import script from "./IconSelectDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconSelectDown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports